module.exports = __webpack_public_path__ + "static/media/ear_256x256.56846958.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ear_256x256.png
// module id = 89
// module chunks = 0